export default function delegateEvent(
    element,
    delegateEvent,
    selector,
    handler,
    capturing = false
) {
    element.addEventListener(
        delegateEvent,
        function (event) {
            var t = event.target;
            while (t && t !== this) {
                if (t.matches(selector)) {
                    handler.call(t, event, t);
                }
                t = t.parentNode;
            }
        },
        capturing
    );
}
